import { ExtendedOfferRequirements } from '../../components/Dialogs/CreateInvite/context/types';
import { InstagramGradientIcon } from '../../components/Icons/InstagramGradientIcon';
import { OfferRequirements } from '../../graphql/API';
import Icons from '../../themes/icons';

export const OFFER_REQUIREMENTS_V2 = [
  {
    id: 1,
    title: 'Tiktok Video',
    description: 'Receive a promotion on Tiktok',
    icon: <Icons.TiktokIcon />,
    activeIcon: <Icons.TiktokIcon />,
    value: [OfferRequirements.postOnTikTokVideo],
  },
  {
    id: 2,
    title: 'Instagram Post',
    description: 'Receive a promotion on Instagram',
    icon: <Icons.InstagramIconV2 />,
    activeIcon: <InstagramGradientIcon />,
    value: [
      OfferRequirements.postOnInstagramStories,
      OfferRequirements.postOnInstagramStories2x,
      OfferRequirements.postOnInstagramStories3x,
      OfferRequirements.postOnInstagramFeed,
      OfferRequirements.postOnInstagramReels,
    ],
  },
  {
    id: 3,
    title: 'Gifting',
    description: 'Gift your product - no posting required',
    icon: <Icons.GiftingIcon />,
    activeIcon: <Icons.GiftingIcon />,
    value: [ExtendedOfferRequirements.noRequirement],
  },
];
